/** Booking fee already captured for this cart */
export function isBookingFeePaid(cart) {
  return (
    cart?.step3Data?.paymentStatus === "completed" &&
    Boolean(cart?.step3Data?.stripePaymentIntentId)
  );
}

/** Payment intent created but not yet completed (e.g. 3DS in progress) */
export function isBookingFeePending(cart) {
  return (
    cart?.step3Data?.paymentStatus === "pending" &&
    Boolean(cart?.step3Data?.stripePaymentIntentId)
  );
}

/** User should complete booking without entering card details again */
export function canCompleteBookingWithoutNewPayment(cart) {
  return isBookingFeePaid(cart) || isBookingFeePending(cart);
}
